/** Placement fee arithmetic for the sign-up calculator. Whole pounds; rounding is per step. */

export function placementFee(salary: number, feePercent: number): number {
  if (!Number.isFinite(salary) || !Number.isFinite(feePercent) || salary <= 0 || feePercent <= 0) return 0;
  return Math.round((salary * feePercent) / 100);
}

/** What a "recruiter-in-a-box" provider takes from one placement fee. */
export function providerCut(fee: number, cutPercent: number): number {
  if (fee <= 0 || cutPercent <= 0) return 0;
  return Math.round((fee * cutPercent) / 100);
}

const gbp = new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 });

export function formatGbp(amount: number): string {
  return gbp.format(amount);
}

/** Parses user-typed money like "£100,000" or "100k". Returns NaN when unreadable. */
export function parseMoney(input: string): number {
  const s = input.trim().toLowerCase().replace(/[£,\s]/g, "");
  if (!s) return NaN;
  const k = s.endsWith("k");
  const n = Number(k ? s.slice(0, -1) : s);
  return Number.isFinite(n) ? (k ? n * 1000 : n) : NaN;
}
